import styled from 'styled-components';

export const CSSVariables = styled.div`
  --tooltip-text-color: white;
  --tooltip-background-color: ${window?.settings?.secondary_color ?? '#04333b'};
  --tooltip-margin: 10px;
  --tooltip-arrow-size: 5px;
`;
